module.exports = "https://static.energy5.com/_next/static/images/brand8-92a0fab436ee888a3891468fdc8369c1.png";